import axiosInstance from "@/api/axios";

export default {
  async getUserStatusHistoryByUser(userId) {
    try {
      const { data } = await axiosInstance.get(`/userStatusHistory/${userId}`);
      return data.data;
    } catch (error) {
      console.log("error en la funcion getUserStatusHistoryByUser", error.message);
    }
  },
  async sendUserStatusHistory(data) {
    try {
      const { data: response } = await axiosInstance.post("/userStatusHistory", data);
      return response.data;
    } catch (error) {
      console.log("error en la funcion sendUserStatusHistory", error.message);
    }
  },
  async updateUserStatusHistory(id, data) {
    try {
      const { data: response } = await axiosInstance.put(`/userStatusHistory/${id}`, data);
      return response.data;
    } catch (error) {
      console.log("error en la funcion updateUserStatusHistory", error.message);
    }
  },
};
